import * as types from '../constants/ActionTypes';
import { groupByName, translateItemTypesName } from '../lib/ExerciseUtils';

export const initialState = {
    contentInvalsiTaxonomy: [],
    errorMsgInvalsiHomework: '',
    errorMsgInvalsiExercise: '',
    exerciseFilters: {
        favouriteOnly: false,
        fromYearOrdinal: null,
        idList: [],
        itemTypesIds: [],
        searchTerm: '',
        subjectsId: [],
        toYearOrdinal: null
    },
    exerciseListInvalsi: [],
    homeworkFavouriteOnly: false,
    homeworkCount: 0,
    homeworkFilters: {
        fromYearOrdinal: null,
        subjectsId: [],
        toYearOrdinal: null
    },
    homeworkListInvalsi: [],
    homeworkPage: 1,
    invalsiExercisesCount: 0,
    invalsiExercisesShowFavouriteToggle: false,
    itemTypesList: [],
    loaded: true,
    loadedInvalsiContentTaxonomy: true,
    loadedInvalsiYearsList: true,
    loadedInvalsiSubjectsList: true,
    searchPage: 0,
    searchTerm: '',
    showHomeworkFavouriteToggle: false,
    subjectsListInvalsi: [],
    yearsList: [],
    isSuggestionSelected: false
};

export default function Invalsi(state = initialState, action = {}) {
    switch (action.type) {
        case types.GET_INVALSI_CONTENT_TAXONOMY:
            return {
                ...state,
                loadedInvalsiContentTaxonomy: false
            };
        case types.GET_INVALSI_CONTENT_TAXONOMY_SUCCESS:
            return {
                ...state,
                loadedInvalsiContentTaxonomy: true,
                contentInvalsiTaxonomy: action.result
            };
        case types.GET_INVALSI_CONTENT_TAXONOMY_FAILURE:
            return {
                ...state,
                contentInvalsiTaxonomy: [],
                errorMsgInvalsiExercise:
                    'Siamo spiacenti, ma per problemi tecnici in questo momento non è possibile ricercare esercizi Zanichelli. Si prega di riprovare più tardi.',
                loadedInvalsiContentTaxonomy: true
            };
        case types.GET_INVALSI_EXERCISE_LIST:
            return {
                ...state,
                errorMsgInvalsiExercise: '',
                exerciseFilters: {
                    ...state.exerciseFilters,
                    favouriteOnly: action.favouriteOnly
                },
                exerciseListInvalsi: [],
                invalsiExercisesCount: 0,
                isSuggestionSelected: action.isSuggestionSelected,
                loaded: false
            };
        case types.GET_INVALSI_EXERCISE_LIST_SUCCESS:
            if (action.result.length < 1) {
                return {
                    ...state,
                    errorMsgInvalsiExercise: 'La ricerca non ha prodotto alcun risultato.',
                    exerciseListInvalsi: [],
                    invalsiExercisesCount: action.totalCount,
                    invalsiExercisesShowFavouriteToggle: !!action.favourites,
                    loaded: true
                };
            } else {
                return {
                    ...state,
                    errorMsgInvalsiExercise: '',
                    exerciseListInvalsi: action.result,
                    invalsiExercisesCount: action.totalCount,
                    invalsiExercisesShowFavouriteToggle: true,
                    loaded: true,
                    searchPage: action.searchPage
                };
            }
        case types.GET_MORE_INVALSI_EXERCISE_LIST: {
            return {
                ...state,
                loaded: false,
                errorMsgInvalsiExercise: ''
            };
        }
        case types.GET_MORE_INVALSI_EXERCISE_LIST_SUCCESS: {
            return {
                ...state,
                errorMsgInvalsiExercise: '',
                exerciseListInvalsi: state.exerciseListInvalsi.concat(action.result),
                invalsiExercisesShowFavouriteToggle: true,
                loaded: true,
                searchPage: action.searchPage
            };
        }
        case types.GET_INVALSI_EXERCISE_LIST_UNAUTHORIZED:
        case types.GET_INVALSI_EXERCISE_LIST_FAILURE:
            return {
                ...state,
                errorMsgInvalsiExercise:
                    'Siamo spiacenti, ma per problemi tecnici in questo momento non è possibile ricercare esercizi Zanichelli. Si prega di riprovare più tardi o con altre chiavi.',
                exerciseListInvalsi: [],
                invalsiExercisesShowFavouriteToggle: false,
                loaded: true
            };
        case types.GET_INVALSI_HOMEWORK_LIST:
            return {
                ...state,
                errorMsgInvalsiHomework: '',
                homeworkFavouriteOnly: action.payload.favouriteOnly,
                homeworkFilters: {
                    fromYearOrdinal: action.payload.fromYearOrdinal,
                    subjectsId: action.payload.subjectsId,
                    toYearOrdinal: action.payload.toYearOrdinal
                },
                homeworkListInvalsi: [],
                homeworkCount: 0,
                homeworkPage: 1,
                loaded: false
            };
        case types.GET_INVALSI_HOMEWORK_LIST_SUCCESS:
            if (action.payload.result.length < 1) {
                return {
                    ...state,
                    errorMsgInvalsiHomework: 'La ricerca non ha prodotto alcun risultato.',
                    homeworkListInvalsi: [],
                    homeworkCount: 0,
                    homeworkPage: 1,
                    loaded: true,
                    showHomeworkFavouriteToggle: !state.homeworkFavouriteOnly ? false : true
                };
            } else {
                return {
                    ...state,
                    errorMsgInvalsiHomework: '',
                    homeworkListInvalsi: action.payload.result,
                    homeworkCount: action.payload.totalCount,
                    homeworkPage: action.payload.searchPage,
                    loaded: true,
                    showHomeworkFavouriteToggle: true
                };
            }
        case types.GET_INVALSI_HOMEWORK_LIST_UNAUTHORIZED:
        case types.GET_INVALSI_HOMEWORK_LIST_FAILURE:
            return {
                ...state,
                errorMsgInvalsiHomework: '',
                homeworkListInvalsi: [],
                loaded: true,
                showHomeworkFavouriteToggle: false
            };

        case types.GET_MORE_INVALSI_HOMEWORK_LIST: {
            return {
                ...state,
                errorMsgInvalsiHomework: '',
                homeworkFavouriteOnly: action.payload.favouriteOnly,
                loaded: false
            };
        }
        case types.GET_MORE_INVALSI_HOMEWORK_LIST_SUCCESS: {
            return {
                ...state,
                errorMsgInvalsiHomework: '',
                homeworkListInvalsi: state.homeworkListInvalsi.concat(
                    action.payload.result.map(invalsiHomework => ({
                        ...invalsiHomework
                    }))
                ),
                homeworkPage: action.payload.searchPage,
                loaded: true
            };
        }
        case types.GET_MORE_INVALSI_HOMEWORK_LIST_FAILURE: {
            return {
                ...state,
                errorMsgInvalsiHomework: action.error,
                loaded: true,
                showHomeworkFavouriteToggle: false
            };
        }

        case types.GET_INVALSI_SUBJECTS_LIST:
            return {
                ...state,
                loadedInvalsiSubjectsList: false,
                subjectsListInvalsi: []
            };
        case types.GET_INVALSI_SUBJECTS_LIST_SUCCESS:
            let noContent = !Array.isArray(action.result);
            return {
                ...state,
                loadedInvalsiSubjectsList: true,
                subjectsListInvalsi: noContent ? [] : groupByName(action.result)
            };
        case types.GET_INVALSI_SUBJECTS_LIST_UNAUTHORIZED:
        case types.GET_INVALSI_SUBJECTS_LIST_FAILURE:
            return {
                ...state,
                loadedInvalsiSubjectsList: true
            };
        case types.GET_INVALSI_YEARS_LIST:
            return {
                ...state,
                loadedInvalsiYearsList: false
            };
        case types.GET_INVALSI_YEARS_LIST_SUCCESS:
            return {
                ...state,
                loadedInvalsiYearsList: true,
                yearsList: action.result
            };
        case types.GET_INVALSI_YEARS_LIST_UNAUTHORIZED:
        case types.GET_INVALSI_YEARS_LIST_FAILURE:
            return {
                ...state,
                yearsList: [],
                loadedInvalsiYearsList: true
            };
        case types.GET_INVALSI_ITEM_TYPES_SUCCESS:
            let itemTypesName = [];
            if (Array.isArray(action.result)) {
                action.result.map(el => {
                    if (el.name.startsWith('exercise.') && el.name !== 'exercise.checker') {
                        return itemTypesName.push({ id: el.id, name: translateItemTypesName(el.name) });
                    } else {
                        return undefined;
                    }
                });
                itemTypesName.sort((a, b) => {
                    let textA = a.name.toUpperCase();
                    let textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            }

            return {
                ...state,
                itemTypesList: itemTypesName
            };
        case types.GET_INVALSI_ITEM_TYPES_FAILURE:
            return {
                ...state,
                itemTypesList: []
            };
        case types.INVALSI_FILTERS_CHANGE: {
            const retStatus = {
                ...state
            };
            if (action.isExercise) {
                retStatus.exerciseFilters = {
                    ...state.exerciseFilters,
                    ...action.filters
                };
            } else {
                retStatus.homeworkFilters = {
                    ...state.homeworkFilters,
                    ...action.filters
                };
            }
            return retStatus;
        }
        default:
            return state;
    }
}
